import "./Calendar.css";

function Calendar({ lang }) {
  return (
    <div className="calendar-card">
      <iframe
        title="Google Calendar"
        src={`https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FNew_York&mode=MONTH&showPrint=0&showCalendars=0&title&${
          lang === "es" ? "hl=es_419" : "hl=en"
        }&src=MDc3ODY3ZTk2MGRjNzg5MWVjYWQwZDIwMzVjNjIwZTVjZmU4ZjllNjM4ZTY4ZDQ0YmYwOWM5ZTQ5MjZkZjc0NEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23a79b8e`}
        style={{
          border: "solid 1px #777",
          width: "100%",
          height: "600px",
          borderRadius: "15px",
          margin: "0",
        }}
      ></iframe>
    </div>
  );
}

export default Calendar;
